var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout__header"},[(_vm.theme === 'rr')?[_c('RRHeader',{attrs:{"activeMenu":"calendar"}}),_vm._v(" "),_c('div',{staticClass:"rr-header-offset"})]:_c(_vm.currentTenantHeader,{tag:"component"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }